import {
  QSetConditionQuestionType,
  type QSetConditionsQuestionType,
} from '@exam-management/graphql';

const QUESTION_TYPE_LABEL = {
  [QSetConditionQuestionType.Single]: 'Single',
  [QSetConditionQuestionType.ItemSet]: 'Item Set',
};

export function formatExamQuestionType(questionTypes: QSetConditionsQuestionType[]) {
  const formattedTypes = questionTypes.map((questionType) => {
    const { type, count } = questionType;
    return `${QUESTION_TYPE_LABEL[type as QSetConditionQuestionType]}: ${count ?? '-'} ข้อ`;
  });

  return formattedTypes.length ? formattedTypes.join(', ') : '-';
}
